export default {
    adjustments: {
        title: "Ajustements",
        reset: "Réinitialiser",
        light: {
            title: "Lumière",
            brightness: "Luminosité",
            contrast: "Contraste",
            shadows: "Les ombres",
        },
        color: {
            title: "Couleur",
            saturation: "Saturation",
            temperature: "Température",
            blacks: "Noirs",
            whites: "Blancs",
        },
        detail: {
            title: "Détail",
            clarity: "Clarté",
            sharpness: "Acuité",
            blur: "Flou",
        },
    },
};
